import React from "react";
import { Link } from "react-router-dom";
import AddFormNumber from "../components/AddFormNumber";
import LogOut from "../components/LogOut";

const AddNumber = () => {
  return (
    <div>
      <div className="navbar_admin">
      <LogOut />
        <h2>لوحة التحكم في حسابات العملاء</h2>
        <button className="add1">
          <Link to="/admin">العودة للرئيسية</Link>
        </button>
      </div>
      <div className="admin_area">
        <AddFormNumber />
      </div>
    </div>
  );
};

export default AddNumber;
